const jQuery = require('jquery');
const hoverIntent = require('jquery-hoverintent');

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('common');
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

//convert this to javascript, no jquery
//https://www.lewagon.com/blog/from-jquery-to-dom-and-es6
(function($) {
    var $container = $('.offcanvas-top'),
		$cHeight = $('.o-content').outerHeight();
	function buildCanvas() {
		$('#mega-menu-item-147 a').bind('click', function(e) {
			e.preventDefault();
			var $this = $(this);
            if($container.hasClass('active')) {
				$container.toggleClass('active');
				$container.height(0);
				//$this.text('Hide -');
			} else {
				$container.toggleClass('active');
				$container.height(60);
				$('#search-input').focus();
				//$this.text('More +');
			}
		});
    }
    $(document).ready(function() {
		buildCanvas();
		$('.panel-collapse.in').parent().addClass('expanded');
	});
	
	$('#top-link a').on('click', function() {
        $('body,html').animate({
            scrollTop: 0
          }, 800, 'easeInOutCirc');
        return false;
    });

    $(document).ready(function() {
      function frontBoxes() {
        $('.front-box').each(function() {
          var $box = $(this).find('.box-title'),
          $this = $(this),
          $height = $box.height(),
          $top = $this.height() - 40,
          $distance = parseInt($top) - $height + 40;
          
          //unbind existing hoverIntent
          $this.unbind("mouseenter").unbind("mouseleave");
          $this.removeProp('hoverIntent_t');
          $this.removeProp('hoverIntent_s');

          //with hover intent
          $this.hoverIntent({
            interval: 50,
            over: function() {
            $box.dequeue().stop().animate({
              top: $distance
            })
            },
            out: function() {
            $box.dequeue().stop().animate({
              top: $top
            })
            }
            });
        });
      }
      frontBoxes();
      
      //Window Resize Listener, with a delay to make sure resizing is done
      var resizeTimer;
      $(window).resize(function() {
          clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
            frontBoxes();
          }, 1500);
      });
    });
})(jQuery); // Fully reference jQuery after this point.


// WEBPACK FOOTER //
// ./src/routes/common.js